import type { PracticeDocumentUpdateSummary } from "@ohf/core";
import { useQuery } from "@tanstack/react-query";
import { useMe } from "../../auth/MeProvider.js";
import { useApi } from "../../auth/SessionProvider.js";
import { documentIdentity } from "./api.js";

export function usePracticeDocumentUpdates(offset = 0, limit = 20) {
  const api = useApi();
  const { me, mfaBlocked } = useMe();
  return useQuery({
    queryKey: ["practice-document-updates", documentIdentity(me), offset, limit],
    queryFn: ({ signal }) => api.get<PracticeDocumentUpdateSummary>(`/practice-document-updates?${new URLSearchParams({ offset: String(offset), limit: String(limit) })}`, signal),
    enabled: Boolean(me?.userId && me.authUserId && me.scope && !mfaBlocked),
    staleTime: 30_000, refetchOnMount: "always", refetchOnWindowFocus: true, retry: false,
  });
}
